<ng-template #updateMessage let-toast
  >A new version of For The Record is available,
  <a ftrFocusableNoopAnchor (click)="restartApp(toast)">restart the app</a> to get the latest features.</ng-template
>
